import { createFileRoute, Outlet } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

import { validateSearch } from './-routeParams';

export const Route = createFileRoute('/(main)/deliveries/all/$deliveryId')({
  component: Outlet,
  validateSearch,
});

export const DELIVERY = buildRouteExport({ Route });
